import StudentsList from "./components/admin/StudentsList";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/Registration/Register";
import Candidate from "./components/Registration/CandidateRegister";
import SchoolRegister from "./components/Registration/SchoolRegister";
import InstructorList from "./components/admin/InstructorList";
import UserProfile from "./components/Profile/UserProfile";
import RegistrationGroup from "./components/Registration/RegistrationGroup";
import StudentProfile from "./components/Profile/StudentProfile";
import EzStudentRegistration from "./components/Registration/EzStudentRegistration";
import Settings from "./Settings/Settings";
import Users from "./pages/Users";
import Organization from "./pages/Organization";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme

const queryParameters = new URLSearchParams(window.location.search);
const organizationCode = queryParameters.get("orgcode")?.toUpperCase();
const subscriberCode = queryParameters.get("subcode")
const username = queryParameters.get("username")
const role = queryParameters.get("role")

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route exact path="/students-data" element={<StudentsList title="Students | Admin" />} />
          <Route path="/student">
            <Route exact path="profile" element={<StudentProfile title="Profile | Student" />} />
            <Route path="registration" element={organizationCode === "VSS" || organizationCode === "VSS_IN" ? <Candidate title="Register | Candidate" /> : <Register title="Register | Student" />} />
            <Route path="ezregistration" element={<EzStudentRegistration title="Register | Student" isUsername={true}/>} />
            <Route path="settings/*" element={<Settings title="Settings | Student" username={username} subCode={subscriberCode} orgCode={organizationCode} role={role}/>}/>
            <Route path="organization/*" element={<Organization title="Organization | User" subCode={subscriberCode} username={username} orgCode={organizationCode}/>}/>
          </Route>
          <Route path="/user">
            <Route exact path="profile" element={<UserProfile title="Profile | User" />} />
          </Route>
          <Route path="/users" element={<Users title="Users"/>} />
          <Route path="/school">
            <Route path="registration" element={<SchoolRegister title="Register | School" />} />
          </Route>
          <Route path="/instructor">
            <Route path="data" element={<InstructorList title="Data | Instructor" />} />
          </Route>
          <Route exact path="/registration-group" element={<RegistrationGroup title="Login | Contacts" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
